import { EntitiesStore } from './entities-store.abstract';
import { HttpClient, HttpParams } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { EventGeneralInfoItem } from 'world-archery-lib';
import { WaHelperService } from '../../../library/wa-services/wa-helper-service';
import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { Injector } from '@angular/core';

/**
 * Interface for events store
 *
 * @export
 * @interface IEvents
 */
export interface IEvents {
  Address:any;
  ID: number;
  Name: string;
  NameShort: string;
  Venue: string;
  Place: string;
  Country: string;
  CountryName: string;
  HeaderImage?: {
    URL: string
  };
  DFrom: string;
  DTo: string;
  WithRes: boolean;
  ComEventType: number;
  ComLevel: number;
  ComSubLevel: number;
  ComDis: number;
  ComDivisions: number[];
  EventType: string;
  Level: string;
  SubLevel: string;
  IsFeatured: boolean;
  WorldRecordStatus: boolean;
  WorldRankingEvent: boolean;
  IsLive: boolean;
  IsCancelled: boolean;
  ComHideInLive: string;
  Options: string[];
  CatInd: any[];
  CatTeam: any[];
  Status: string;
  Stages: any[];
  YoutubeLive: string;
  Links: Links;
  Logo: Logo;
}
interface Links {
  Web: string;
  "Registration URL":string;
  "Result URL":string;
  "E-Mail":string|string[];
  "Phone":string;
  "Mobile":string;
}
interface Logo {
  URL: string;
  MimeType: string;
}

/**
 * Events store
 *
 * @export
 * @class EventsStore
 * @extends {EntitiesStore<IEvents>}
 */
export class EventsStore extends EntitiesStore<EventGeneralInfoItem> {
  constructor(http: HttpClient, private helper: WaHelperService, injector: Injector) {
    super('COMPETITIONS', http, [{ entity: new CountryDependencyEntityStore(http, injector) }]);

  }
  protected getRequest(params: any, request_more: boolean) {
    return super.getRequest(params, request_more).pipe(tap(next => {
      const data = next.items.map(value => Object.assign(new EventGeneralInfoItem(value, this.helper), { statusId: (value as any).StatusId }));
      this.dataStream.next(data as any);
      this.data = data as any;
      this.pagination = next.pageInfo;
      this.loadingRef = false;
      this.requestMore = false;
    }));
  }


}
